import React, {useState, useEffect} from 'react';
import { Table, Button, Row, Col, Switch, Tooltip, notification, Input } from 'antd';
import { FaPlusCircle, FaPencilAlt, FaCoins } from "react-icons/fa";
import { getActiveCategories, getProductStorageLocations, addToStorageLocation } from '../services/CategoriesService'
import { getAllUnitsOfMeasure } from '../services/UnitsOfMeasureService'
import { getAllCostCategory } from '../services/CostCategoryService'
import { getAllPlants } from '../services/PlantsService'
import { addProduct, getProducts, updateProduct } from '../services/ProductsService'
import { normalized } from '../utils/string';

import ProductModalNew from './ProductModalNew';
import ProductModalEdit from './ProductModalEdit';
import ProductModalStorage from './ProductModalStorage';

function Products(){
    const[dataProducts, setDataProducts] = useState([]);
    const[dataCategories, setDataCategories] = useState([]);
    const[categoryId, setCategoryId] = useState("");
    const[modalVisibleNew, setModalVisibleNew] = useState(false);
    const[modalVisibleEdit, setModalVisibleEdit] = useState(false);
    const[modalVisibleStorage, setModalVisibleStorage] = useState(false);
    const[nameProduct, setNameProduct] = useState("");
    const[descProduct, setDescProduct] = useState("");
    const[activeProduct, setActiveProduct] = useState("");
    const[idProduct, setIdProduct] = useState("");
    const[idPlant, setIdPlant] = useState("");
    const[unitProduct, setUnitProduct] = useState("");
    const[tableProductsLoading, setTableProductsLoading] = useState(false);
    const[dataUnits, setDataUnits] = useState([]);
    const[dataPlantsStorage, setDataPlantsStorage] = useState([]);
    const[dataProductStorage, setDataProductStorage] = useState([]);
    const[dataKeysStorage, setDataKeysStorage] = useState([]);
    const[dataTableStorage, setDataTableStorage] = useState([]);
    const[costCategoryId, setCostCategoryId] = useState('');
    const[filterCategory, setfilterCategory] = useState([]);
    const[searchValue, setSearchValue] = useState('');
    const[tempProducts, setTempProducts] = useState([]);


    useEffect(() => {
        async function process(){
          const { data } = await getActiveCategories();
          setDataCategories(data);
          const filter = [];
          data.map(function(obj){
            const item = {
              "text": obj.name,
              "value": obj.name
            };
            filter.push(item);
            return true;
          });
          setfilterCategory(filter);
        }
        async function unitsOfM(){
          const { data } = await getAllUnitsOfMeasure();
          setDataUnits(data);
        }
        async function costCategory(){
          const { data } = await getAllCostCategory();
          setCostCategoryId(data[0].id);
        }
        async function plantsStorage(){
          const { data } = await getAllPlants();
          setDataPlantsStorage(data);
          setIdPlant(data[0].id)
        }
        async function products(){
          setTableProductsLoading(true);
          const { data } = await getProducts();
          setDataProducts(data);
          setTempProducts(data);
          setTableProductsLoading(false);
        }
        products();
        process();
        unitsOfM();
        costCategory();
        plantsStorage();
        
    },[])

    const msNotification = (type, title, desc) => {
        notification[type]({
          message: title,
          description:
            desc,
        });
    };

    const handleClickModalNew = () => {
        setModalVisibleNew(true);
    }
  
    const handleClickModalEdit = (record) => {
        setNameProduct(record.name);
        //setUrlThumbnail(record.uriThumbnail);
        setIdProduct(record.id);
        setUnitProduct(record.baseUnit.id);
        //setCostCatProduct(record.costCategoryId);
        setDescProduct(record.description);
        //setPriceProduct(record.cost);
        setActiveProduct(record.active);
        setCategoryId(record.category.id);
        setModalVisibleEdit(true);
    }

    const handleClickModalStorage = (record) => {
      setNameProduct(record.name);
      setIdProduct(record.id);
      setCategoryId(record.category.id);
      async function prodStorage(){
        const { data } = await getProductStorageLocations(record.category.id, record.id);
        setDataProductStorage(data);
        const dataStorage = [];
        const keysStorage = [];
        const dataPlant = dataPlantsStorage.find(x => x.id === idPlant);
        dataPlant.storageLocations.map(function(obj){
            const row = {
                id: obj.id,
                storageLocationId: obj.id,
                almacen: obj.name,
                stock: 0,
                safeStock: 0
                //costCategoryId: costCategoryId
            };
            const ps = data.filter(p => p.storageLocationId === obj.id);
            if(ps.length > 0){
                row.stock = ps[0].stock;
                row.safeStock = ps[0].safeStock;
                keysStorage.push(obj.id);
            }
            dataStorage.push(row);
            return true;
        });
        setDataTableStorage(dataStorage);
        setDataKeysStorage(keysStorage);
        setModalVisibleStorage(true);
      }
      prodStorage();
      
  }

    const onChangeActive = (record, checked) => {
        const request = {
            "Name": record.name,
            "CategoryId": record.category.id,
            "Description": record.description,
            "Active": checked,
            "BaseUnitId": record.baseUnit.id
          };

        async function updateTheProduct(){
          try {
              await updateProduct(record.id, request);  
              const dataProd = [...dataProducts]
              dataProd.find(x => x.id === record.id).active = checked;
              setDataProducts(dataProd); 
              setTempProducts(dataProd);
              msNotification('success', 'Producto', 'Se actualizó el producto.' );
          } catch (error) {
            msNotification('error', 'Producto', 'Error al actualizar el producto.' );
          } finally {
              //setUploading(false);
          }
        }
        updateTheProduct();
    }

    const handleOkModalNew = (data) =>{
      const dataProd = [...dataProducts];
      const exist = dataProd.find(x => x.id.toUpperCase() === data.prodId.toUpperCase());
      if(exist === undefined){
        
        const request = {
          "Id": data.prodId,
          "Name": data.prodName,
          "CategoryId": data.prodCategory,
          "Description": data.prodDesc,
          "Active": true,
          "BaseUnitId": data.prodUnit,
        };
        const model = {
          "id": data.prodId,
          "name": data.prodName,
          "description": data.prodDesc,
          "active": true,
          "baseUnit": {
            "id": data.prodUnit
          },
          "category": {
            "id": data.prodCategory,
            "name": data.prodCategoryName
          }
        };
        async function addNewProduct(){
            try {
                await addProduct(request);
                const tempProducts = [...dataProducts];
                tempProducts.push(model);
                setDataProducts(tempProducts);
                setTempProducts(tempProducts);
                msNotification('success', 'Producto', 'Se creó el producto.' );
            } catch (errors) {
                msNotification('error', 'Producto', 'Error al crear el producto.' );
            } finally {
              setModalVisibleNew(false);
            }
        }
        addNewProduct();
      }else{
        msNotification('warning', 'Producto', `El Id: ${data.prodId} ya lo tiene asignado el producto: ${exist.name}.` );
      }
        
  
    }

    const handleOkModalEdit = (datac) =>{
        const requestProduct = {
            "CategoryId": categoryId,
            "Name": datac.prodName,
            "Description": datac.prodDesc,
            //"Cost": parseFloat(datac.prodPrice),
            "Active": activeProduct,
            "BaseUnitId": unitProduct,
            //"CostCategoryId": datac.prodCostCat
          };
        async function updateTheProduct(){
            try {
                await updateProduct(idProduct, requestProduct);   
                const dataProd = [...dataProducts]
                dataProd.find(x => x.id === idProduct).name = datac.prodName;
                dataProd.find(x => x.id === idProduct).description = datac.prodDesc;
                setDataProducts(dataProd); 
                setTempProducts(dataProd);
                msNotification('success', 'Producto', 'Se actualizó el producto.' );
            } catch (error) {
                msNotification('error', 'Producto', 'Error al actualizar el producto.' );
            } finally {
              setModalVisibleEdit(false);
            }
        }
        if(datac.prodName !== nameProduct || datac.prodDesc !== descProduct){
            updateTheProduct();
        }
        
    }
  
    const handleCancelModalNew = () =>{
        setModalVisibleNew(false);
    }

    const handleCancelModalEdit = () =>{
        setModalVisibleEdit(false);
    }

    const handleOkModalStorage = async (plant, data) =>{
      const request = {
        "PlantId": plant,
        "CategoryId": categoryId,
        "CostCategoryId": costCategoryId,
        "StorageLocations": data
      };

      try {
        await addToStorageLocation(categoryId,idProduct,request);
        setModalVisibleStorage(false);
        msNotification('success', 'Almacén', 'Se actualizaron los almacenes.' );
      } catch (error) {
        setModalVisibleStorage(false);
        if(error.response && error.response.status === 400)
          notification['warning']({ description: error.response.data });
      }
    }

    const handleCancelModalStorage = () =>{
      setModalVisibleStorage(false);
      setDataKeysStorage([]);
    }

    const handleSearchProduct = (e) =>{
      const currValue = e.target.value;
      setSearchValue(currValue);
      const filteredData = dataProducts.filter(entry =>
        normalized(entry.id).includes(normalized(currValue))||
        normalized(entry.name).includes(normalized(currValue))||
        normalized(entry.description).includes(normalized(currValue))
      );
      if(currValue !== ""){
          setDataProducts(filteredData);
      }else{
          setDataProducts(tempProducts);
      }
      
  };

    const columns = [
      {
        title: "Información",
        render: (record) => (
          <React.Fragment>
            {record.id}
            <br />
            {record.name}
            <br />
            {record.category.name}
          </React.Fragment>
        ),
        responsive: ["xs"]
      },
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          responsive: ["sm"]
        },
        {
          title: 'Producto',
          dataIndex: 'name',
          responsive: ["sm"]
        },
        {
            title: 'Descripción',
            dataIndex: 'description',
            responsive: ["sm"]
        },
        {
            title: 'Categoría',
            dataIndex: 'category',
            render: (value) => (value.name),
            filters: filterCategory,
            onFilter: (value, record) => record.category.name.indexOf(value) === 0,
            responsive: ["sm"]
        },
        // {
        //   title: '',
        //   dataIndex: 'uriThumbnail',
        //   align: 'center',
        //   key: 'uriThumbnail',
        //   render: (value) => ( value !== null ? <img className='imgTableProd' src={origin + value} /> : "")
        // },
        {
          title: '',
          dataIndex: 'active',
          align: 'center',
          key: 'active',
          render: (value, record) => (<Switch checked={value} onChange={(checked) => onChangeActive(record, checked)} />)
        },
        {
          title: '',
          align: 'center',
          render: (value, record) => (
            <React.Fragment>
              <Tooltip title="Editar">
                <Button type="primary" shape="circle" onClick={() => handleClickModalEdit(record)} icon={<FaPencilAlt />} />
              </Tooltip>
              <Tooltip title="Almacenes">
                <Button type="primary" shape="circle" onClick={() => handleClickModalStorage(record)} icon={<FaCoins />} />
              </Tooltip>
            </React.Fragment>)
        },
      ];


    return(
        <div className="mainContainer">

            <ProductModalNew modalVisibleNew={modalVisibleNew} 
              handleCancelModalNew={handleCancelModalNew}
              dataUnits={dataUnits}
              dataProducts={dataProducts}
              dataCategories={dataCategories}
              handleOkModalNew={handleOkModalNew}/>

            <ProductModalEdit modalVisibleEdit={modalVisibleEdit} 
              handleCancelModalEdit={handleCancelModalEdit}
              handleOkModalEdit={handleOkModalEdit}
              //urlThumbnail={urlThumbnail}
              dataUnits={dataUnits}
              unitProduct={unitProduct}
              categoryId={categoryId}
              //dataCostCategory={dataCostCategory}
              nameProduct={nameProduct}
              descProduct={descProduct}
              //priceProduct={priceProduct}
              idProduct={idProduct}/>

            <ProductModalStorage modalVisibleStorage={modalVisibleStorage} 
              handleCancelModalStorage={handleCancelModalStorage}
              dataPlantsStorage={dataPlantsStorage}
              nameProduct={nameProduct}
              dataProductStorage={dataProductStorage}
              handleOkModalStorage={handleOkModalStorage}
              idPlant={idPlant}
              dataTableStorage={dataTableStorage}
              dataKeysStorage={dataKeysStorage}
              idProduct={idProduct}/>

            <Row>
                <Col span={24}>
                    <h1 className="title">Productos</h1>
                    <hr className="hr-title"/>
                </Col>
            </Row>

            <Row className="detailContainer">
                <Col span={24}>
                    <div className="divRight">
                        <Button type="primary" icon={<FaPlusCircle/>} onClick={handleClickModalNew}>
                          &nbsp; Nuevo
                        </Button>
                    </div>
                </Col>
                <Col span={6} offset={18}>
                        <br/>
                        <Input
                            placeholder="Buscar producto"
                            value={searchValue}
                            onChange={handleSearchProduct}/>
                </Col>
                <Col span={24}>
                    <br/>
                    <Table rowKey="id" dataSource={dataProducts} columns={columns} loading={tableProductsLoading}/>
                </Col>
            </Row>

        </div>
    )    

}

export default Products;


// WEBPACK FOOTER //
// ./src/components/Products.jsx